import React, { useContext } from 'react';
import { AuthContext } from 'AuthContext';

const PrivateRoute = ({ children, roleRequired }) => {
  const { token, role } = useContext(AuthContext);
  if (!token) {
    return <p>Non connecté</p>;
  }
  if (roleRequired && role !== roleRequired) {
    return <p>403 Forbidden</p>;
  }
  return children;
};

export default PrivateRoute;